<div class="row">
  <div class="col-12 col-md-6 offset-md-3">
    @if (error) {
      <div class="alert alert-danger">
        <p>{{ error }}</p>
      </div>
    }
    @if (isLoading) {
      <div  class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    }
    @if (!isLoading) {
      <form #authForm="ngForm" (ngSubmit)="onSubmit(authForm)">
        <div class="mb-3">
          <label for="userName">User Name</label>
          <input
            type="text"
            id="userName"
            class="form-control"
            ngModel
            name="userName"
            required
            />
          </div>
          <div class="mb-3">
            <label for="password">Password</label>
            <input
              type="password"
              id="password"
              class="form-control"
              ngModel
              name="password"
              required
              />
            </div>
            <div class="form-check mb-3">
              <input
                type="checkbox"
                class="form-check-input"
                id="stay"
                name="stay"
                [checked] = "stay_logged"
                [(ngModel)]="stay_logged"
                />
                <label class="form-check-label" for="stay">
                  Stay logged in on this computer
                </label>
              </div>
              <div>
                <button
                  class="btn btn-primary"
                  type="submit"
                  [disabled]="!authForm.valid"
                  >
                  Login
                </button>
              </div>
            </form>
          }
        </div>
      </div>
